import axios from 'axios';
import { Auth } from 'aws-amplify';
import store from '@/store';

let restoring = null;

// Nach einem Reload ist der Vuex-Store leer, das Cognito-Token liegt aber noch
// im Browser. Daraus den Login-Zustand wiederherstellen, statt zum Login zu springen.
const restore = async () => {
  try {
    const user = await Auth.currentAuthenticatedUser();
    const customerId = parseInt(user.username.substr(0, user.username.indexOf('_')));
    const baseUrl = store.state.baseUrl;
    const [profile, customer, customers] = await Promise.all([
      axios.get(`${baseUrl}profile`),
      axios.get(`${baseUrl}customer`),
      axios.create().get(`${baseUrl}customerpublic`).catch(() => ({ data: [] })),
    ]);
    const publicCustomer = (customers.data || []).find(c => c.customer_id === customerId);

    store.commit('setCustomerId', customerId);
    store.commit('setCustomerName', publicCustomer ? publicCustomer.name : null);
    store.commit('setCognitoUsername', user.username);
    store.commit('setProfile', profile.data);
    store.commit('setCustomer', customer.data);
    store.commit('setIsUserLoggedIn', true);
    return true;
  } catch (error) {
    return false;
  }
};

export const restoreSession = () => {
  if (store.state.isLoggedIn) return Promise.resolve(true);
  // parallele Navigationen teilen sich einen Versuch
  if (!restoring) {
    restoring = restore().finally(() => {
      restoring = null;
    });
  }
  return restoring;
};
